module.exports = __webpack_public_path__ + "img/Cookie_1_resize_07.8099cd82.png";